<!-- wrapper starts -->
<app-notify-message></app-notify-message>
<div class="container-fluid wrapper">
  <div class="form-container col-lg-8 p-4">
    <!-- begin login-header -->
    <div class="loginHeader my-4">
      <div class="logo-container">
        <img src="../../../assets/img/CleverCharge logo.png" alt="logo">
      </div>
    </div>
    <!-- end login-header -->

    <!-- login form starts -->
    @if (!verificationReq) {
      <form
        action="javascript:void(0);"
        method="POST" #f="ngForm"
        (ngSubmit)="checkLogin(f.valid)"
        novalidate>
        <h3 class="loginC text-center">Login</h3>
        <div class="loginAlert container">
          <small class="text-danger text-center">{{message}}</small>
        </div>
        <!-- username div starts -->
        <div class="sm-form-design form-field">
          <input
            type="text"
            autocapitalize="none"
            autofocus
            name="userName" id="cf_email"
            class="form-control h5-email"
            placeholder="User Name"
            value=""
            tabindex="1"
            maxlength="35"
            #userName="ngModel"
            [(ngModel)]="login.userName"
            required="required"
            />
            <label class="control-label left-10">User Name</label>
            <div class="error-container" [hidden]="userName.valid || (userName.pristine && !f.submitted)">
              <small class="text-danger">Please enter User Name</small>
            </div>
          </div>
          <!-- username div ends -->
          <!-- password div starts -->
          <div class="sm-form-design form-field">
            @if (typePassword) {
              <i (click)="togglePassword()" class="fa fa-eye show-password"></i>
            }
            @if (!typePassword) {
              <i (click)="togglePassword()" class="fa fa-eye-slash show-password"></i>
            }
            <input
              type="{{ typePassword ? 'text' : 'password' }}"
              class="form-control h5-email password-box"
              autocapitalize="none"
              placeholder="Password"
              id="cf_password" name="password"
              value=""
              tabindex="2"
              maxlength="46"
              [(ngModel)]="login.password"
              #password="ngModel" required
              />
              <label class="control-label left-10">Password</label>
              <div class="error-container" [hidden]="password.valid || (password.pristine && !f.submitted)">
                <small class="text-danger">Please enter Password</small>
              </div>
            </div>
            <!-- password div ends -->
            <a routerLink="/forgot-password" class="forgot_password mt-1">Forgot Password?</a>
            <button class="btn btn-peak btn-block btn-lg border-0 submit-btn mb-4" type="submit" [disabled]="disable">Login</button>
          </form>
        }
        <!-- login form ends -->

        <!-- Verification code form starts -->
        @if (verificationReq) {
          <form
            action="javascript:void(0);"
            method="POST" #f="ngForm"
            (ngSubmit)="getMfaToken(f.valid)"
            novalidate>
            <h3 class="loginC text-center">Verify Your Identity</h3>
            <div class="loginAlert container mb-2 text-center">
              <small class="text-danger text-center">{{message}}</small>
            </div>
            <!-- Info start -->
            <p>You're trying to <b>Log In</b> to CleverCharge. To make sure your CleverCharge account is secure, we have to verify your identity.</p>
            <p>A verification Code has been sent to your email address. Use the code to login.</p>
            <p><b>Username: {{login.userName}}</b></p>
            <!-- Info end -->
            <!-- code div starts -->
            <div class="sm-form-design form-field">
              <input
                type="text"
                autocapitalize="none"
                autofocus
                name="verificationCode" id="cf_email"
                class="form-control h5-email"
                placeholder="Verification Code"
                value=""
                tabindex="1"
                maxlength="6"
                #verificationCode="ngModel"
                [(ngModel)]="otp"
                required="required"
                />
                <label class="control-label left-10">Verification Code</label>
                <div class="error-container" [hidden]="verificationCode.valid || (verificationCode.pristine && !f.submitted)">
                  <small class="text-danger">Please enter Verification Code</small>
                </div>
              </div>
              <!-- code div ends -->
              <button class="btn btn-lg border-0 mt-1 resendBtn" type="button" [disabled]="resetDisable" (click)="resetOtp()">
                Resend Code @if (resetDisable) {
                <span>({{resendTimer}})</span>
              }
            </button>
            <button class="btn btn-peak btn-block btn-lg border-0 submit-btn mb-4" type="submit" [disabled]="disable">
              @if (disable) {
                <span class="mr-1"><i class="fa fa-circle-o-notch fa-spin fa-fw"></i></span>
              }
              Verify
            </button>
            <!-- <button class="btn btn-peak btn-block btn-lg border-0 submit-btn mb-2 width100" type="submit" [disabled]="disable">
            <span *ngIf="disable" class="mr-1"><i class="fa fa-circle-o-notch fa-spin fa-fw"></i></span>
            Verify
          </button>
          <button class="btn btn-peak btn-block btn-lg border-0 submit-btn mb-4" type="button" [disabled]="resetDisable" (click)="resetOtp()">
            Resend Code <span *ngIf="resetDisable">({{resendTimer}})</span>
          </button> -->
        </form>
      }
      <!-- Verification code form ends -->
    </div>
    <!-- footer starts -->

    <p class="copyrights-footer col text-center">
      &copy; {{footerText}}
    </p>
    <!-- footer ends -->
  </div>
  <!-- wrapper ends   -->